// @flow
import React from 'react';
import Tooltip from '@homeaway/react-tooltip';

import type {Node} from 'react';

type DesktopProps = {
    content: string,
    children: Node
};

const DualPriceTooltipDesktop = ({content, children}: DesktopProps) => {
    return (
        <Tooltip
            tooltipType="popover"
            placement="bottom"
            content={content}
            centered
            wrapperClassName="DualPriceTooltip"
        >
            {children}
        </Tooltip>
    );
};

export default DualPriceTooltipDesktop;
